import { render, staticRenderFns } from "./PermissionGroupModal.vue?vue&type=template&id=54459621"
import script from "./PermissionGroupModal.vue?vue&type=script&lang=js"
export * from "./PermissionGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports